import { Avatar as AntAvatar } from 'antd';
import { AvatarProps } from 'antd/lib/avatar';
import * as React from 'react';

const Avatar: React.StatelessComponent<AvatarProps> = props => {
  return <AntAvatar {...props} />;
};

export default Avatar;
